export const resumeLink = "/resume.pdf";

export const profileLinks = [
  {
    title: "GitHub",
    url: "https://github.com/Tony301",
  },
  {
    title: "LinkedIn",
    url: "https://www.linkedin.com/in/tony-b-bb070911a",
  },
];

export const projects = [
  {
    title: "VR Accident Investigation",
    type: "VR Training",
    platform: "PC / Windows",
    description:
      "Industrial VR simulation where users explore a scene, gather evidence objects via ray-cast or direct grab, and determine the root cause of an accident. Features real-time investigation tracking, structured evidence flow, and a quiz-based conclusion with retry system.",
    tags: ["Unity", "VR", "XR Interaction", "C#", "Industrial Simulation"],
    video:
      "https://github.com/Tony301/my-portfolio-react/releases/download/v1.0-media/Simbott_Test_Tony.-.Main.-.Windows.Mac.Linux.-.Unity.2022.3.62f2._DX11_.2026-04-10.21-05-40.mp4",
  },
  {
    title: "VR Room Viewer",
    type: "VR Visualization",
    platform: "PC / VR",
    description:
      "Real-estate walkthrough tool in VR with true-to-life room dimensions. Buyers can teleport through demo flats and swap furniture in real time to visualize their ideal layout before purchasing.",
    tags: ["Unity", "VR", "Real Estate", "Furniture Customization", "C#"],
    video: "https://github.com/Tony301/my-portfolio-react/releases/download/v1.0-media/Room.1.mp4",
  },
  {
    title: "QCDC AR App",
    type: "Mobile AR",
    platform: "Android",
    description:
      "Android AR application built with AR Foundation. Supports plane detection, object placement with anchor locking, pinch-to-resize, and toggleable label overlays — all on-device with no cloud dependency.",
    tags: ["Unity", "AR Foundation", "Android", "XR", "C#"],
    video: "https://github.com/Tony301/my-portfolio-react/releases/download/v1.0-media/Working.video.mp4",
  },
  {
    title: "WebGL Multiplayer Game",
    type: "Multiplayer / Social",
    platform: "WebGL / Browser",
    description:
      "Real-time multiplayer WebGL experience using Photon for networking and Firebase for authentication. Players join social rooms, chat via text and voice, customise their avatar, and interact with other users — no download required.",
    tags: ["Unity", "WebGL", "Photon", "Firebase", "Multiplayer", "C#"],
    video:
      "https://github.com/Tony301/my-portfolio-react/releases/download/v1.0-media/TEST.Unity.WebGL.Player._.Event.-.Google.Chrome.2023-05-01.10-48-05.mp4",
    screenshots: [
      "/My%20work/Done/Webgl%20multiplayert%20game/Screenshot%202026-06-21%20194311.png",
      "/My%20work/Done/Webgl%20multiplayert%20game/Screenshot%202026-06-21%20194329.png",
      "/My%20work/Done/Webgl%20multiplayert%20game/Screenshot%202026-06-21%20194344.png",
      "/My%20work/Done/Webgl%20multiplayert%20game/Screenshot%202026-06-21%20194357.png",
    ],
  },
  {
    title: "Web AR",
    type: "Browser AR",
    platform: "Web / Any Browser",
    description:
      "Browser-based AR experience with no app install required. Opens directly in any modern mobile browser and overlays interactive 3D objects onto the real world using WebXR.",
    tags: ["Unity", "WebXR", "AR", "Browser", "No-Install"],
    video:
      "https://github.com/Tony301/my-portfolio-react/releases/download/v1.0-media/testingAr.by.Tony.Bera.-.Google.Chrome.2023-05-07.14-00-46.mp4",
  },
  {
    title: "Casual Games Collection",
    type: "2D Games",
    platform: "Mobile / PC",
    description:
      "A set of polished casual games built during early freelance years: Pong, Tic Tac Toe with multiplayer, Hexagone (shape-avoidance), Running Man (endless runner), and Vegetable Crush (match-3). Each shipped with clean UI and responsive controls.",
    tags: ["Unity", "2D", "Casual", "Multiplayer", "Mobile", "C#"],
    video: "https://github.com/Tony301/my-portfolio-react/releases/download/v1.0-media/casual-games.mp4",
    screenshots: [
      "/My%20work/Done/Some%20casual%20games%20from%20my%20earlier%20days/Screenshot%202026-06-21%20194426.png",
      "/My%20work/Done/Some%20casual%20games%20from%20my%20earlier%20days/Screenshot%202026-06-21%20194447.png",
      "/My%20work/Done/Some%20casual%20games%20from%20my%20earlier%20days/Screenshot%202026-06-21%20194534.png",
    ],
  },
];

export const skills = [
  "Unity 3D / 2D",
  "C# Development",
  "VR Development",
  "AR / AR Foundation",
  "WebGL Builds",
  "Photon Networking",
  "UniTask & Addressables",
  "Performance Optimization",
  "Level Design",
  "Asset Management",
];

export const experience = [
  {
    role: "Unity Developer",
    company: "Feast Software Pvt Ltd",
    location: "Mumbai, India",
    period: "Nov 2024 – Present",
    bullets: [
      "Developing VR-based training applications for multiple industrial use cases",
      "Designing interactive simulations to improve user learning and engagement",
      "Implementing optimized interaction systems for XR environments",
    ],
  },
  {
    role: "Unity Game Developer",
    company: "Improvement Interactive",
    location: "Remote",
    period: "Jun 2023 – Nov 2024",
    bullets: [
      "Built real-time simulation systems and immersive environments in Unity",
      "Developed procedural terrain generation and object spawning systems",
      "Optimized async workflows using UniTask and Addressables",
      "Integrated WebSocket-based communication for real-time features",
    ],
  },
  {
    role: "Lead Unity Developer",
    company: "Eventcombo",
    location: "Remote",
    period: "Jun 2022 – Apr 2023",
    bullets: [
      "Led development of a web-based metaverse platform",
      "Implemented chat systems, player interactions, and social features",
      "Developed dynamic content systems (posters, link-based access)",
      "Enabled real-time communication including video call features",
    ],
  },
  {
    role: "Unity XR Developer",
    company: "Cusmat Technologies Pvt Ltd",
    location: "Remote",
    period: "May 2021 – Apr 2022",
    bullets: [
      "Developed AR/VR applications for training and simulation",
      "Built mobile-based interactive tutorial applications",
      "Translated client requirements into technical solutions",
    ],
  },
  {
    role: "Unity Game Developer Intern",
    company: "Appzia Technologies Pvt Ltd",
    location: "Pune, India",
    period: "Feb 2021 – May 2021",
    bullets: [
      "Developed 2D, 3D, and VR games in a fast-paced environment",
      "Performed testing and debugging across multiple game projects",
    ],
  },
];
